<template>
  <div id="app">
    <transition
      :name="transitionName"
      :mode="transitionMode"
    >
      <keep-alive include="TreeAnimation">
        <router-view />
      </keep-alive>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      transitionName: '',
      transitionMode: '',
    }
  },
  watch: {
    '$route' (to, from) {
      if (from.name === 'AppCover' && to.name === 'Home') {
        this.transitionName = 'fade-out-in'
        this.transitionMode = 'out-in'
      } else if (
        (from.name === 'Home' && to.name === 'TreeAnimation') ||
        (from.name === 'TreeAnimation' && to.name === 'TreeSelection') ||
        (from.name === 'TreeSelection' && to.name === 'Chart') ||
        (from.name === 'Chart' && to.name === 'End')
      ) {
        this.transitionName = 'slide-to-next-page'
        this.transitionMode = ''
      } else {
        this.transitionName = ''
        this.transitionMode = ''
      }
    }
  },
  mounted() {
  }
}
</script>

<style>
html,body{
  width: 100%;
  height: 100%;
}
.nav {
  position: fixed;
  top: 0;
  z-index: 999;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
}

.slide-to-next-page-enter {
  position: fixed;
  bottom: 100%;
  left: 0;
  width: 100%;
  height: 100%;
}

.slide-to-next-page-enter-to {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.slide-to-next-page-enter-active {
  transition: bottom 1s;
}

.slide-to-next-page-leave {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.slide-to-next-page-leave-to {
  position: fixed;
  bottom: -100%;
  left: 0;
  width: 100%;
  height: 100%;
}

.slide-to-next-page-leave-active {
  transition: bottom 1s;
}

.fade-out-in-enter {
  opacity: 0;
}

.fade-out-in-enter-to {
  opacity: 1;
}

.fade-out-in-enter-active {
  transition: opacity 1s;
}

.fade-out-in-leave {
  opacity: 1;
}

.fade-out-in-leave-to {
  opacity: 0;
}

.fade-out-in-leave-active {
  transition: opacity 1s;
}
</style>
